/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Slot_ShowInputs */

const en_slot_show = /** @type {(inputs: Slot_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.name} in the plan`)
};

const de_slot_show = /** @type {(inputs: Slot_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} im Plan zeigen`)
};

/**
* | output |
* | --- |
* | "Show {name} in the plan" |
*
* @param {Slot_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_show = /** @type {((inputs: Slot_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_show(inputs)
	return en_slot_show(inputs)
});